/*
    create by igor
    usage when imported: .catch((err) => errorCatcher(err));
*/
import { Rollbar } from '@app-masters/js-lib';

const errorCatcher = (err) => {
    console.log(err);
    const user = localStorage.getItem('user');
    if (user) {
        Rollbar.error(err, err.message, user);
    } else {
        Rollbar.log(err);
    }

    let message = err.message;
    if (err.message === 'Failed to fetch') {
        message = 'Erro de conexão';
    } else {
        message = 'Houve um erro inesperado e os programadores responsáveis já foram avisados.';
    }
    window.alert(message);
};

export default errorCatcher;



// WEBPACK FOOTER //
// ./src/utils/errorCatcher.js